import { render } from "./RightSidebarComponent.vue?vue&type=template&id=e170f142&scoped=true"
import script from "./RightSidebarComponent.vue?vue&type=script&lang=js"
export * from "./RightSidebarComponent.vue?vue&type=script&lang=js"

import "./RightSidebarComponent.vue?vue&type=style&index=0&id=e170f142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e170f142"]])

export default __exports__